import type { FC, PropsWithChildren, ReactNode } from 'react'
import { Children, isValidElement, cloneElement } from 'react'
import styled from '@emotion/styled'

import type { Document as RichTextDocument } from '@contentful/rich-text-types'
import { BLOCKS } from '@contentful/rich-text-types'

import Typography from '@segment/matcha/components/Typography'

import RichText from '@segment/matcha/recipes/RichText'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import { ListItem } from '@segment/matcha/recipes/RichText/List'

const render = () => {
  return {
    [BLOCKS.PARAGRAPH](_: any, children: ReactNode) {
      return (
        <StyledTypography variant="pMedium" tag="p">
          {children}
        </StyledTypography>
      )
    },
    [BLOCKS.LIST_ITEM]: (_: any, children: ReactNode) => (
      <ListItem>
        {Children.map(children, (child) => {
          if (isValidElement(child)) {
            return cloneElement(child, { ...child.props, variant: `pSmall` })
          }
        })}
      </ListItem>
    ),
  }
}

interface ContentsProps {
  data: RichTextDocument
}
const Contents: FC<PropsWithChildren<ContentsProps>> = ({ data }) => {
  return (
    <StyledSectionBase variant="noCopy">
      <Section.Contents>
        <RichText data={data} options={{ renderNode: render() }} />
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`xl`)} {
      max-width: 992px;
      margin: 0 auto;
    }
  }
`

const StyledTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.brand.darkAcai[`500`]};
`

export default Contents
